import { render, staticRenderFns } from "./agentorder-component.vue?vue&type=template&id=35646922"
import script from "./agentorder-component.vue?vue&type=script&lang=ts"
export * from "./agentorder-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports